/*
 * AgeValidationModal Messages
 *
 * This contains all the text for the AgeValidationModal component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.AgeValidationModal.title',
    defaultMessage: 'Ingresa tu fecha de nacimiento',
  },
  subtitle: {
    id: 'app.components.AgeValidationModal.subtitle',
    defaultMessage:
      'La venta de este producto está prohibida a menores de edad. Si sos menor no podrás agregarlo a tu pedido.',
  },
  inputTitle: {
    id: 'app.components.AgeValidationModal.inputTitle',
    defaultMessage: 'Fecha de nacimiento',
  },
  acceptButton: {
    id: 'app.components.AgeValidationModal.acceptButton',
    defaultMessage: 'Aceptar',
  },
});
